export default __webpack_public_path__ + "static/casual-ec9f4981653fc6dfe7dfc345cc28a4dd.svg";